// modules
import { createSelector } from 'reselect'
import { get } from 'lodash'

const agencyCaseManagement$ = (state) =>
  get(state, ['admin', 'agencyCaseManagement'], {})

export const agencyCaseManagementList$ = createSelector(
  agencyCaseManagement$,
  ({ list = [] }) => list
)

export const agencyCaseManagementEditItem$ = createSelector(
  agencyCaseManagement$,
  ({ editItem = {} }) => editItem
)
